<template>
    <v-dialog v-model="createOps.dialog" max-width="500px">
        <v-card flat>
            <v-card-title>
                <v-row align="center">
                    <v-col cols="10">
                        <span>Create Task</span>
                    </v-col>
                    <v-col cols="2">
                        <div class="float-right">
                            <CustomButton
                                btnIcon="mdi-close"
                                tooltipMsg="Close"
                                @click="hideDialog"
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-divider />

            <v-card-text class="px-4">
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer" v-slot="{}">
                            <v-form>
                                <v-row dense>
                                    <v-col cols="12">
                                        <CustomLabel
                                            for="name"
                                            label="Name"
                                            required
                                        />
                                        <CustomTextField
                                            id="name"
                                            inputPlaceholder="Name"
                                            :inputValue="createPayload.name"
                                            validationName="name"
                                            validationRules="required"
                                            @input="
                                                updateForm(
                                                    $event,
                                                    'createPayload.name'
                                                )
                                            "
                                        />
                                    </v-col>
                                </v-row>

                                <v-row class="mt-4">
                                    <v-col>
                                        <CustomButton
                                            btnLabel="Cancel"
                                            tooltipMsg="Cancel"
                                            @click="hideDialog"
                                        />
                                        <CustomButton
                                            btnColour="primary"
                                            :btnIsLoading="createOps.isLoading"
                                            btnLabel="Save"
                                            tooltipMsg="Save"
                                            @click="createItems(createPayload)"
                                        />
                                    </v-col>
                                </v-row>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";

extend("required", {
    ...required,
    message: "Field cannot be empty.",
});

export default {
    computed: {
        ...mapState("tasksAdminMgmt", ["createOps", "createPayload"]),
    },
    data: () => ({}),
    methods: {
        async createItems(payload) {
            let valid = await this.$refs.observer.validate();

            if (!valid) {
                return;
            }

            let response = await this.$store.dispatch(
                "tasksAdminMgmt/createItems",
                payload
            );

            if (response) {
                this.$refs.observer.reset();
            }
        },
        hideDialog() {
            this.$store.commit("tasksAdminMgmt/HIDE_CREATE_OPS_DIALOG");
            this.$store.commit("tasksAdminMgmt/FLUSH_FIELD", "createPayload");
            this.$refs.observer.reset();
        },
        updateForm(event, form) {
            if (event instanceof InputEvent) {
                this.$store.commit("tasksAdminMgmt/UPDATE_FORM", {
                    payload: {
                        form: form,
                        value: event.target.value,
                    },
                });
                return;
            } else if (
                event instanceof String ||
                typeof event == "boolean" ||
                typeof event == "number" ||
                typeof event == "string"
            ) {
                this.$store.commit("tasksAdminMgmt/UPDATE_FORM", {
                    payload: {
                        form: form,
                        value: event,
                    },
                });
                return;
            } else {
                return;
            }
        },
    },
    name: "DialogTaskCreate",
    // Lifecycle hooks.
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
};
</script>
